module.exports = __webpack_public_path__ + "static/img/logo-hrzy.4815e00a.png";